import React from 'react'

import {
  FieldSpec,
  LinkedPathField,
  NumberField,
  PaginatedTable,
  RelatedLinkedField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key: string]: FieldSpec } = {
  client: {
    id: 'sku.client',
    label: 'Client',
    ordering: 'sku__client__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  sku: {
    id: 'sku',
    label: 'SKU',
    ordering: 'sku__sku',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  place: {
    id: 'place',
    label: 'Place',
    ordering: 'place__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  numToPick: {
    id: 'numToPick',
    label: 'Number of Units to Pick',
    ordering: 'num_to_pick',
    renderer: NumberField,
  },
  totalStored: {
    id: 'totalStored',
    label: 'Total in Location',
    ordering: 'total_stored',
    renderer: NumberField,
  },
  path: {
    id: 'place.objPath',
    label: 'Path',
    ordering: 'place__search_path',
    renderer: LinkedPathField,
  },
}

export const ReplenishmentListTable = (props: ListTableProps) => {
  const { paginator, title, fields } = props

  return (
    <>
      <PaginatedTable
        title={title || 'Replenishment Plan'}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
      />
    </>
  )
}
